import { PropsWithChildren } from 'react';

export default function Table({ children }: PropsWithChildren) {
   return (
      <table className="rounded-t-lg w-full bg-gray-200 text-gray-800">
         {children}
      </table>
   );
}
